<div fxLayout="column" style="overflow-y: auto; max-height: 600px; width: 650px;">
  <!-- Basic -->
  <mat-accordion>
    <mat-expansion-panel style="padding: unset;">
      <mat-expansion-panel-header>
        <mat-panel-title fxLayout="row" fxLayoutAlign="center center" style="margin-right: 0px;">
          <div fxFlex="10" class="sensor-image" [style.background-color]="sensor.getCssColor()"
            [style.-webkit-mask-image]="sensor.getSvgSymbol()">
          </div>
          <app-basic-field-r fxFlex="20" [RealValue]="sensor.SensorType" [Title]="'Type' | translate">
          </app-basic-field-r>
          <app-basic-field-r fxFlex="20" [RealValue]="sensor.sensorID+'/'+sensor.sic+'/'+sensor.sac" [Title]="'ID/SIC/SAC'">
          </app-basic-field-r>
          <app-basic-field-r fxFlex="45" [RealValue]="sensor.name" [Title]="'FIELDS.NAME' | translate">
          </app-basic-field-r>       
        </mat-panel-title>
      </mat-expansion-panel-header>

      <!-- add content here... -->
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" style="margin-top: 10px; margin-right: 12px;">
        <!-- on/off -->
        <!-- <mat-slide-toggle [(ngModel)]="sliderState" (change)="sliderClick()" style="position: absolute; left: 12%;">
        </mat-slide-toggle> -->

        <button class="small-button" mat-stroked-button (click)="hookSensor()"
          [matTooltip]="'ACTIONS.HOOK' | translate">
          <mat-icon class="svg-icon">touch_app</mat-icon>
        </button>

        <button class="small-button" mat-stroked-button (click)="setCenter()"
          [matTooltip]="'ACTIONS.CENTER' | translate">
          <mat-icon class="svg-icon">place</mat-icon>
        </button>

        <button class="small-button" mat-stroked-button (click)="openAro()" [matTooltip]="'ACTIONS.ARO' | translate">
          <mat-icon class="svg-icon">assignment</mat-icon>
        </button>

        <!-- <button class="small-button" mat-stroked-button (click)="deleteSensor()"
          [matTooltip]="'ACTIONS.DELETE' | translate">
          <mat-icon class="svg-icon">delete</mat-icon>
        </button> -->
      </div>


    </mat-expansion-panel>
  </mat-accordion>
</div>